module.exports = __webpack_public_path__ + "img/3.a84d05a2.jpg";